module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "owl-carousel slider-navigation"
  }, _vm._l((_vm.items), function(item) {
    return _c('div', {
      staticClass: "item"
    }, [_c('div', {
      staticClass: "containerItem3"
    }, [_c('div', {
      staticClass: "left"
    }, [_c('a', {
      staticClass: "img",
      style: ({
        'background-image': 'url(' + item.img + ')'
      }),
      attrs: {
        "href": item.href
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "right"
    }, [_c('div', {
      staticClass: "contentContainer"
    }, [_c('div', {
      staticClass: "textHidden"
    }, [_c('div', {
      staticClass: "text-header"
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(item.header) + "\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', [_c('a', {
      staticClass: "button waves-effect waves-light",
      attrs: {
        "href": item.href
      }
    }, [_vm._v(_vm._s(item.button))])])])])])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-659141fd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/includes/components/sliders/slider-photo2.vue
// module id = 252
// module chunks = 35